import { useEffect, useRef, useState } from 'react'

export const defaultFloatOptions = {
  openDelay: 100,
  closeDelay: 100,
}

export interface UseFloatHoverOptions {
  openDelay?: number
  closeDelay?: number
}

export const useFloatHover = (options: UseFloatHoverOptions = defaultFloatOptions) => {
  const [show, setShow] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  const open = () => {
    if (timer.current !== null) {
      clearTimeout(timer.current)
      timer.current = null
    }
    setShow(true)
  }

  useEffect(() => {
    if (show && timer.current) {
      setShow(false)
    }
  }, [show])

  const delayOpen = () => {
    if (timer.current !== null) {
      clearTimeout(timer.current)
      timer.current = null
    }
    setTimeout(() => {
      setShow(true)
    }, options.openDelay ?? defaultFloatOptions.openDelay)
  }

  const close = () => {
    setShow(false)
  }

  const delayClose = () => {
    timer.current = setTimeout(() => {
      setShow(false)
    }, options.closeDelay ?? defaultFloatOptions.closeDelay)
  }
  return { show, open, close, delayClose, delayOpen }
}
